const headers = [
  
  {
    label: "ชื่อไฟล์",
    field: "fileName",
  },
  {
    label: "ประเภทเอกสาร",
    field: "file",
  },
  {
    label: "วันที่อัพโหลด",
    field: "createDate",
  },  
  // {
  //   label: "Action",
  //   field: "action",
  // },
];

export default headers;
